import request from '../request';
import Api, { handleError, handleData } from '../Api';

import { url } from './config';
import { ExchangeRate } from './types';
import { BodyAddManyExchangeRates, GetRatesByCurrenciesQueryBody } from './context/BodyTypes';

class ExtendedApi extends Api<ExchangeRate> {
    getAll() {
        return request.get(`${url}-all`).then(handleData).catch(handleError);
    }
    async addMany(body: BodyAddManyExchangeRates) {
        try {
            const res = await request.post(`${url}-add-many`, body);
            return res.data;
        } catch (error) {
            handleError(error);
            throw error;
        }
    }
    async getRatesByCurrencies(query: GetRatesByCurrenciesQueryBody) {
        try {
            const res = await request.get(`${url}-by-currinces`, { params: query });
            return handleData(res);
        } catch (error) {
            return handleError(error);
        }
    }
    // Bank of Israel representative rates (שער יציג) effective on `date` (ms/ISO). Keyed by ISO code.
    async getBoiRates(date?: number | string) {
        try {
            const res = await request.get(`${url}/boi`, { params: { date } });
            return handleData(res);
        } catch (error) {
            handleError(error);
            return {};
        }
    }
    // Bank Leumi transfers/cheques buy & sell effective on `date` (ms/ISO). Keyed by ISO code.
    async getLeumiRates(date?: number | string) {
        try {
            const res = await request.get(`${url}/leumi`, { params: { date } });
            return handleData(res);
        } catch (error) {
            handleError(error);
            return {};
        }
    }
    // Manual "Fetch now": apply Bank Leumi rates for the client immediately. Returns the run summary.
    async autoFetchNow(clientId: string) {
        try {
            const res = await request.post(`${url}/auto-fetch-now`, { clientId });
            return res.data;
        } catch (error) {
            handleError(error);
            throw error;
        }
    }
}

const api = new ExtendedApi(url);

export default api;
